import { Panel } from 'rsuite';
import styled from 'styled-components';

export default styled(Panel)`
  > .rs-panel-body {
    padding: 10px 15px;
    > a {
      float: right;
      margin: 5px 0px;
    }
    .rs-row > .rs-col {
      margin: 5px 0px;
    }
  }
`;
